import { h, Fragment } from 'preact'
// import { useSelector } from "react-redux";
// import { routesSelector } from '@state/routes/routesSelector'

import { modelTypes } from 'app/constants'
import { redirect } from 'app/utils/misc'

import withProvider from '@state/withProvider'
import useSSR from '@core/hooks/useSSR'
import translate from '@core/translate'

import AddedToCartItem from './AddedToCartItem'

function AddedToCart({
	// the product which was added
	productName,
	productQuantity,

	// will hold an array of products to cross-sell
	crossSells = [],
}) {
	const { cartSettings, routes } = useSSR([modelTypes.cartSettings, modelTypes.routes])
	const checkoutUrl = cartSettings.onePageCheckoutEnabled
		? routes.checkout.onepage
		: routes.checkout.normal

	function handleCloseClick() {
		window._drawerManager?.closeAll()
	}

	function handleNavigateToCartClick() {
		redirect(checkoutUrl)
	}

	return (
		<Fragment>
			<header className="added-to-cart__header">
				<span className="added-to-cart__header__title">
					{translate('wombit.addedToCart.productAdded', productName, productQuantity)}
				</span>

				<span className="added-to-cart__header__hint">
					{translate('wombit.addedToCart.relatedProductsHint')}
				</span>
			</header>

			<div className="added-to-cart__content">
				<ul className="added-to-cart__content__products">
					{crossSells.map(crossSellItem => (
						<li key={crossSellItem.id}>
							<AddedToCartItem {...crossSellItem} />
						</li>
					))}
				</ul>
			</div>

			<footer className="added-to-cart__footer">
				<button className="button button-primary" type="button" onClick={handleNavigateToCartClick}>
					{translate('wombit.addedtocart.tocheckout')}
				</button>

				<button
					className="button button-secondary --inverted"
					type="button"
					onClick={handleCloseClick}
				>
					{translate('wombit.addedtocart.keepshopping')}
				</button>
			</footer>
		</Fragment>
	)
}

export default withProvider(AddedToCart)
